'use strict';

module.exports = identity;

function identity(value) {
  return value;
}